import { client } from ".";

/**
 * Fetch the authenticated astrologer's leads. Pagination + filters
 * supported by the backend (status, classification, leadType, search,
 * date range) but unused on this client; the leads page paginates
 * client-side off the full set today.
 */
export const fetchLeads = async ({ astrologerId, accessToken }) => {
    try {
        const { data, status } = await client.get(
            `/api/leads/astrologer/${astrologerId}`,
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        );
        return { status, data };
    } catch (err) {
        throw new Error(`Unable to fetch leads: ${err}`);
    }
}

/**
 * Astrologer-scoped lead update. Backend whitelists Lead_status,
 * Lead_classification, and append-Remarks; other fields are silently
 * ignored. Pass only the fields the user changed — the patch is
 * additive on the server side.
 *
 * For a notes append, pass `Remarks: "<the new note>"`; the server
 * timestamps and concatenates onto the existing Remarks string
 * rather than overwriting. The previous timeline stays intact.
 */
export const updateLeadByAstrologer = async ({ leadId, accessToken, payload }) => {
    try {
        const { data, status } = await client.put(
            `/api/leads/astrologer/${leadId}`,
            payload,
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        );
        return { status, data };
    } catch (err) {
        const status = err?.response?.status || 500;
        const message = err?.response?.data?.message || err.message || "Unable to update lead";
        return { status, error: message, data: null };
    }
};